import { call, put, take, takeLatest } from "redux-saga/effects";
import {
  LOGIN_FAIL,
  LOGIN_LOADING,
  LOGIN_SUCCESS,
} from "../actions/returnType";
import {
  DISTRIBUTER_PROFILE,
  FORGET_PASSWORD,
  LOGIN,
  LOGOUT,
  PORTAL_LOGIN,
  RESET_PASSWORD,
  SIGNUP,
  VERIFY_EMAIL,
  DISTRIBUTER_EDIT,
  DISTRIBUTOR_IMG_LOGO,
  CREATE_NEW_PASSWORD,
} from "../actions/types";
import * as authApi from "../apis/authApi";
import { socket } from "../config";

export function* loginWorker(action) {
  try {
    yield put({ type: LOGIN_LOADING });
    const res = yield call(authApi.loginApi, {
      email: action.email,
      password: action.password,
    });
    console.log(res);
    if (res.status == "200") {
      if (res.data.data.distributorData.email_verified == true) {
        localStorage.setItem("id", res.data.data.distributorData.id);
        localStorage.setItem("accessToken", res.data.data.access_token);
        localStorage.setItem(
          "emailVerified",
          res.data.data.distributorData.email_verified
        );
        localStorage.setItem(
          "isDetails",
          res.data.data.distributorData.is_details
        );
        localStorage.setItem(
          "isContactDetails",
          res.data.data.distributorData.is_contact_details
        );
        localStorage.setItem("email", res.data.data.distributorData.email);
        socket.emit("connected", res.data.data.distributorData.id);
        localStorage.setItem("userId", res.data.data.distributorData.id);
      }
      yield put({
        type: LOGIN_SUCCESS,
        message: res.data.message,
        accessToken: res.data.data.access_token,
        emailVerified: res.data.data.distributorData.email_verified,
      });
      yield action.onSuccess(res);
    } else {
      yield put({ type: LOGIN_FAIL, message: res.data.message });
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      "data": {
        message: "Something went wrong"
      }
    })
  }
}

export function* signupWorker(action) {
  try {
    const res = yield call(authApi.signupApi, {
      email: action.email,
      password: action.password,
      confirm_password: action.confirm_password,
    });
    console.log(res.status);
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      "data": {
        message: "Something went wrong"
      }
    })
  }
}


export function* verifyEmailWorker(action) {
  try {
    const res = yield call(authApi.verifyEmail, {
      verifyToken: action.id,
    });
    console.log(res);
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else if (res.status == "409") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      "data": {
        message: "Something went wrong"
      }
    })
  }
}

export function* forgetPasswordWorker(action) {
  try {
    const res = yield call(authApi.forgetPasswordApi, {
      email: action.email,
    });
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
    console.log(res);
  } catch (error) {
    yield action.onError({
      "data": {
        message: "Something went wrong"
      }
    })
  }
}

export function* resetPasswordWorker(action) {
  try {
    const res = yield call(authApi.resetPasswordApi, {
      resetToken: action.id,
      password: action.password,
      confirm_password: action.confirm_password,
    });

    console.log(res);
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      "data": {
        message: "Something went wrong"
      }
    })
  }
}

export function* logoutWorker(action) {
  try {
    const res = yield call(authApi.logoutApi, {});
    console.log(res);
    if (res.status == "200") {
      localStorage.clear();
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      "data": {
        message: "Something went wrong"
      }
    })
  }
}

export function* portalLoginWorker(action) {
  try {
    yield put({ type: LOGIN_LOADING });
    const res = yield call(authApi.portalLoginApi, {
      token: action.token,
    });
    console.log(res);
    if (res.status == 200) {
      localStorage.clear();
      if (res.data.data.distributorData.email_verified == true) {
        localStorage.setItem("id", res.data.data.distributorData.id);
        localStorage.setItem("accessToken", res.data.data.access_token);
        localStorage.setItem(
          "emailVerified",
          res.data.data.distributorData.email_verified
        );
        localStorage.setItem(
          "isDetails",
          res.data.data.distributorData.is_details
        );
        localStorage.setItem(
          "isContactDetails",
          res.data.data.distributorData.is_contact_details
        );
        localStorage.setItem("email", res.data.data.distributorData.email);
        localStorage.setItem("userId", res.data.data.distributorData.id);
        socket.emit("connected", res.data.data.distributorData.id);
      }
      yield put({
        type: LOGIN_SUCCESS,
        message: res.data.message,
        accessToken: res.data.data.access_token,
        emailVerified: res.data.data.distributorData.email_verified,
      });
      yield action.onSuccess(res);
    } else {
      yield put({ type: LOGIN_FAIL, message: res.data.message });
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      "data": {
        message: "Something went wrong"
      }
    })
  }
}

export function* distributorProfileWorker(action) {
  try {
    const res = yield call(authApi.distributerProfileApi, action.id);
    console.log(res);
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      "data": {
        message: "Something went wrong"
      }
    })
  }
}

export function* distributerEditWorker(action) {
  try {
    const res = yield call(authApi.distributerProfileEditApi, action.data);
    console.log(res);
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      "data": {
        message: "Something went wrong"
      }
    })
  }
}

export function* distributerLogoUpldWorker(action) {
  try {
    const file = new FormData();
    file.append("file", action.image);
    const res = yield call(authApi.DistributerLogoUploadApi, file);
    console.log(res);
    if (res.status == 200) {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      "data": {
        message: "Something went wrong"
      }
    })
  }
}

export function* createNewPasswordWorker(action) {
  try {
    const res = yield call(authApi.createNewPasswordApi, action.data);
    console.log(res);
    if (res.status == "200") {
      localStorage.clear();
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError(error);
  }
}

export function* loginWatcher() {
  yield takeLatest(LOGIN, loginWorker);
}

export function* signupWatcher() {
  yield takeLatest(SIGNUP, signupWorker);
}

export function* verifyEmailWatcher() {
  yield takeLatest(VERIFY_EMAIL, verifyEmailWorker);
}

export function* forgetPasswordWatcher() {
  yield takeLatest(FORGET_PASSWORD, forgetPasswordWorker);
}
export function* logoutWatcher() {
  yield takeLatest(LOGOUT, logoutWorker);
}

export function* resetPasswordWatcher() {
  yield takeLatest(RESET_PASSWORD, resetPasswordWorker);
}

export function* portalLoginWatcher() {
  yield takeLatest(PORTAL_LOGIN, portalLoginWorker);
}
export function* distributorProfileWatcher() {
  yield takeLatest(DISTRIBUTER_PROFILE, distributorProfileWorker);
}

export function* distributerEditWatcher() {
  yield takeLatest(DISTRIBUTER_EDIT, distributerEditWorker);
}

export function* distributerLogoUpldWatcher() {
  yield takeLatest(DISTRIBUTOR_IMG_LOGO, distributerLogoUpldWorker);
}

export function* createNewPasswordWatcher() {
  yield takeLatest(CREATE_NEW_PASSWORD, createNewPasswordWorker);
}